import { render, staticRenderFns } from "./OshaForm.vue?vue&type=template&id=7961e00c"
import script from "./OshaForm.vue?vue&type=script&lang=js"
export * from "./OshaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports